<style scope>
</style>

<template>
  <section class="container">
    <orcamento-piller-prospect/>
  </section>
</template>

<script>
  import OrcamentoPillerProspect from './piller/OrcamentoPillerProspect'

  export default {
    components: {OrcamentoPillerProspect},
    created () {
      if (!this.$store.state.parametros || !this.$store.state.parametros.id) {
        this.$air.sair()
        this.$root.$emit('acessar')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/orcamento/FormProspect.vue